<div fxFlex="80" fxFlexOffset="10">
  <div class="toto">
    <h2 class="title-CVM">Run Scripts</h2>
    @if (scripts.length !== 0) {
    <mic-app-run-script [scriptFunction]="scripts"></mic-app-run-script>
    } @else {
    <mic-empty-state icon="layers_clear" title="There is no Function to display."> </mic-empty-state>
    }
  </div>
</div>
